import request from './index';

export interface ILocaleItem {
  code: string;
  label: string;
  language_code: string;
  default?: boolean;
  date_format?: string;
  decimal_separator?: string;
  thousands_separator?: string;
  currency?: string;
  currency_symbol?: string;
  first_day_of_week?: string;
  measurement_units?: string;
}

export interface ILocalesResponse {
  data: ILocaleItem[];
}

/** language_codes: opcjonalnie filtruj po językach (np. available_language_codes firmy). */
export const getLocales = (languageCodes?: string[]) =>
  request<ILocalesResponse>({
    options: languageCodes?.length
      ? {
        url: '/locales',
        method: 'get',
        data: { language_codes: languageCodes }
      }
      : {
        url: '/locales',
        method: 'get'
      }
  });
